import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setOpenTextInstructionModal,
  setTextInstructionId,
  setTextTextInstruction,
  setInlineTextInstruction,
} from '../../../../store/modules/script-editor/actions';
import { selectTextInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerTextActions } from './utils';
import TextInstructionModal from './TextInstructionModal';

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const TextInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectTextInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_TEXT_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenTextInstructionModal(true));
          dispatch(setTextInstructionId(data.instructionId));
          dispatch(setTextTextInstruction(data.text));
          dispatch(setInlineTextInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_TEXT_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerTextActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerTextActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <TextInstructionModal instanceEditor={instanceEditor} />
  );
};

export default TextInstructionComponent;
